

exports.__esModule = true;
exports.$ChooseCreditOfferRoute = undefined;

require('./directive');

var _squid = require('squid');

var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {

    path: 'chooseCreditOffer',
    directive: 'xo-choose-credit-offer',
    titleContent: 'chooseCreditOffer.choose',
    query: [
    // This param is sent from external pages (ie. checkout lite) to indicate that the user started the transaction
    // already and that it's safe to retrieve the session. Session is needed to decide where to route after the
    // CYCO page is complete.
    'populateSession'],
    trackingData: {
        fptiState: 'choose_credit_offer',
        buzname: {
            fullpage: {
                pagename: '%::choose_credit_offer',
                pagename2: '%::choose_credit_offer:member:hermes:',
                version: 'member:%:'
            }
        }
    },
    auth: false,
    children: []
});

angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/choose-credit-offer/route.js
// module id = ../node_modules/xo-credit-components/src/choose-credit-offer/route.js
// module chunks = 0